import React, { useContext } from 'react'
import classnames from 'classnames'
import { useNode, UserComponent } from '@craftjs/core'

import {
  useCellStyles,
} from './utils'

import {
  ILayout_Cell,
  ILayout_Cell_Config,
  ILayout_RenderMap,
  ILayout_Options,
} from '@kaidam/fc-shared/src/types/layout'

import EditorContext from './EditorContext'
import TextRender from './renderers/Text'
import RenderCell from '@kaidam/fc-shared/src/layout/RenderCell'
import icons from '../../icons'
const LockedIcon = icons.lock

const renderers: Partial<ILayout_RenderMap> = {
  text: TextRender,
}

interface CellProps extends ILayout_Cell {
  className?: string,
  options: ILayout_Options,
}

const Cell: UserComponent<CellProps> = ({
  className,
  options,
}) => {

  const {
    id,
    config,
    props,
    connectors: {connect, drag},
  } = useNode(node => {
    const config: ILayout_Cell_Config = node.data.props.config || {}
    return {
      id: node.id,
      props: node.data.props,
      config,
    }
  })

  const editorContext = useContext(EditorContext)

  const cell: ILayout_Cell = {
    type: props.type,
    isNew: props.isNew,
    config: props.config || {},
    data: props.data,
  }

  const classes = useCellStyles({
    config,
    editorMode: true,
  })

  return (
    <div
      className={ classnames('Layout-Editor-Node', 'Layout-Editor-Cell', className, classes.cell) }
      ref={ref => connect(drag(ref))}
    >
      <div
        className={ classnames('Cell-Inner', classes.content) }
        onDoubleClick={ () => {
          editorContext.setEditorEvent({id, action: 'edit'})
        }}
      >
        <RenderCell
          cell={ cell }
          renderers={ renderers }
        />
        {
          editorContext.options.lockedCells && config.locked && (
            <div className={ classes.locked }>
              <LockedIcon /> Locked
            </div>
          )
        }
      </div>
    </div>
  )
}

Cell.craft = {
  displayName: 'cell',
  defaultProps: {
    
  },
  rules: {
    canDrag: (node) => {
      if(node.data.props.options.disableMove) return false
      return true
    },
  }
}

export default Cell